<template>
    <b-card no-body>
        <v-table    ref="table"
                    :fields="fields"
                    :buttons="buttons"
                    :items-provider="provider"
                    pagination="server"
                    search>
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-3">
                                    <select class="form-control" v-model="isIgnored" v-on:change="$refs.table.refresh()">
                                        <option :value="null">Tümü</option>
                                        <option :value="true">Yasaklılar</option>
                                        <option :value="false">Yasaklı Olmayanlar</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import IsbankasiHGSOperationApi from '@/api/isbankasi-hgs-operations'

export default {
    components:{
        BCard
    },
    data(){
        return {
            fields:[
                {name:"Durum",component:true,componentOptions:{name:"hgs-gise-ignored/HGSGiseIgnored"}},
                {name:'Gişe',key:'Name',thClass:'w-100'},
            ],
            buttons:[
                { text:"Yasakla",key:"ignore",icon:"XCircleIcon",variant:"secondary",action:this.ignore,condition:(item) => !item.IsIgnored},
                { text:"Yasağı Kaldır",key:"edit",icon:"CheckCircleIcon",variant:"success",action:this.ignore,condition:(item) => item.IsIgnored},
            ],
            isIgnored:null
        }
    },
    methods:{
        provider(data){
            return IsbankasiHGSOperationApi.GiseTable({
                IsIgnored:this.isIgnored,
                Pagination:data
            })
        },
        ignore(item){
            this.$refs.table.rowLoading(true)
            IsbankasiHGSOperationApi.GiseSetIgnoredStatus(item.Id).then(res=>{
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
                this.$refs.table.rowLoading(false)
                this.$result(res)
            }).catch(err => {
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        }
    }
}
</script>